"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableLoader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableLoader = require("./TableLoader.style");

var _LoadingScreen = require("../LoadingScreen.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TableLoader = ({
  columns,
  columnCount,
  rowCount,
  theme,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_TableLoader.StyleTableLoader, props, columns.length !== 0 && /*#__PURE__*/_react.default.createElement(_TableLoader.StyledRow, null, columns.map((c, i) => /*#__PURE__*/_react.default.createElement(_TableLoader.StyledHead, {
    key: `head-cell-${i}`,
    index: '' + i,
    className: "table-item",
    length: columns.length
  }, c))), Array.from({
    length: rowCount
  }).map((r, i) => {
    return /*#__PURE__*/_react.default.createElement(_TableLoader.StyledRow, {
      key: `row-${i}`
    }, Array.from({
      length: columns.length > 0 ? columns.length : columnCount
    }).map((c, j) => columns.length > 0 ? /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, {
      className: "table-item",
      key: `row-${i}-col-${j}`,
      width: j === 1 ? '40%' : `calc(60%/${columns.length - 1})`,
      height: "16px",
      theme: theme
    }) : /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, {
      className: "table-item",
      key: `row-${i}-col-${j}`,
      width: j === 1 ? '40%' : `calc(60%/${columnCount})`,
      height: "16px",
      theme: theme
    })));
  }));
};

exports.TableLoader = TableLoader;
TableLoader.defaultProps = {
  columnCount: 5,
  rowCount: 12,
  columns: []
};
TableLoader.propTypes = {
  /**
   *  column count for table loader
   * */
  columnCount: _propTypes.default.number.isRequired,

  /**
   * row count for  table laoder
   */
  rowCount: _propTypes.default.number.isRequired,

  /**
   *  header data for table loader
   * */
  columns: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * white background :'light' ,
   * dark background:'dark'
   */
  theme: _propTypes.default.oneOf(['light', 'dark'])
};